exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pickr{width:0;height:0;opacity:0;visibility:hidden}", ""]);

// exports
